export default __webpack_public_path__ + "pgnv-assets/9a0ddaa677d620b208f72d17d928cb54.png";